/* Maqam — Inject per-variant price under each size pill (Bundle 14) */
/* Reads window-scoped product JSON or fetches /products/<handle>.js, then writes
   the price into each variant label as <span class="maqam-price">. Wraps the
   existing label text in <span class="maqam-size"> for clean styling. */

(function () {
  'use strict';

  function formatMoney(cents, currency) {
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    var withCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return withCommas + ' ' + currency;
  }

  function decorateLabels(productData) {
    if (!productData || !productData.variants) return;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EGP';
    var containers = document.querySelectorAll('.productView-variants[data-type="button"] .product-form__input');

    containers.forEach(function (fieldset) {
      var optionIndex = parseInt(fieldset.getAttribute('data-option-index') || '0', 10);
      var labels = fieldset.querySelectorAll('label');

      labels.forEach(function (label) {
        if (label.querySelector('.maqam-size')) return; // already done

        // Match by variant id (locale-safe) — falls back to option text
        // matching only if the label is missing data-variant-id
        var variantId = label.getAttribute('data-variant-id');
        var matchingVariant = null;
        if (variantId) {
          matchingVariant = productData.variants.find(function (v) {
            return String(v.id) === String(variantId);
          });
        }
        if (!matchingVariant) {
          var input = fieldset.querySelector('input[id="' + label.getAttribute('for') + '"]') ||
                      label.previousElementSibling;
          var optionValue = (input && input.value) || label.textContent.trim();
          matchingVariant = productData.variants.find(function (v) {
            var optKey = 'option' + (optionIndex + 1);
            return (v[optKey] || '').toString().trim() === optionValue.toString().trim();
          });
        }

        // Wrap original text in .maqam-size
        var originalText = label.textContent.trim();
        var sizeSpan = document.createElement('span');
        sizeSpan.className = 'maqam-size';
        sizeSpan.textContent = originalText;

        // Clear label children except the radio input (which usually sits before label, not inside)
        // Preserve any visually-hidden helper spans
        var hidden = label.querySelector('.visually-hidden');
        label.innerHTML = '';
        label.appendChild(sizeSpan);

        if (matchingVariant && typeof matchingVariant.price === 'number') {
          var priceSpan = document.createElement('span');
          priceSpan.className = 'maqam-price';
          priceSpan.innerHTML = '<span class=money>' + formatMoney(matchingVariant.price, currency) + '</span>';
          label.appendChild(priceSpan);
        }

        if (hidden) label.appendChild(hidden);
      });
    });
  }

  function getProductHandle() {
    var path = window.location.pathname;
    var m = path.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  function loadProduct() {
    // Try inline JSON first (Ella often exposes it)
    var jsonScript = document.querySelector('[data-product-json]') ||
                     document.querySelector('script[type="application/json"][id*="product"]');
    if (jsonScript) {
      try {
        var raw = jsonScript.textContent.trim();
        var parsed = JSON.parse(raw);
        if (parsed && parsed.variants) {
          decorateLabels(parsed);
          return;
        }
      } catch (e) { /* fall through to fetch */ }
    }

    var handle = getProductHandle();
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(decorateLabels)
      .catch(function () { /* silent */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadProduct);
  } else {
    loadProduct();
  }

  // Re-decorate after Ella swaps variants via AJAX
  document.addEventListener('variant:change', loadProduct);
  document.addEventListener('product:variant-change', loadProduct);
})();
